import axios from "axios";
import { ENV } from "../config/env";

const axiosInstance = axios.create({
  baseURL: ENV.API_BASE_URL,
});

export default axiosInstance;

// import axios from "axios";
// import { ENV } from "../config/env";
// import {
//   getAccessToken,
//   getRefreshToken,
//   setTokens,
//   clearTokens,
// } from "../utils/storage";

// const axiosInstance = axios.create({
//   baseURL: ENV.API_BASE_URL,
// });

// // REQUEST → add access token
// axiosInstance.interceptors.request.use((config) => {
//   const token = getAccessToken();
//   if (token) {
//     config.headers.Authorization = `Bearer ${token}`;
//   }
//   return config;
// });

// // RESPONSE → refresh token on 401
// axiosInstance.interceptors.response.use(
//   (response) => response,
//   async (error) => {
//     const originalRequest = error.config;

//     if (error.response?.status === 401 && !originalRequest._retry) {
//       originalRequest._retry = true;

//       try {
//         const refreshToken = getRefreshToken();

//         const res = await axios.post(
//           `${ENV.API_BASE_URL}/auth/refresh-token`,
//           { refreshToken }
//         );

//         setTokens(res.data.accessToken, res.data.refreshToken);

//         originalRequest.headers.Authorization =
//           `Bearer ${res.data.accessToken}`;

//         return axiosInstance(originalRequest);
//       } catch (err) {
//         clearTokens();
//         // window.location.href = "/login";
//         return Promise.reject(err);
//       }
//     }

//     return Promise.reject(error);
//   }
// );

// export default axiosInstance;
